const Notification = () =>
  import(
    /* webpackChunkName: "messages-notification" */ '@/pages/message/messages/notification/index.vue'
  )
const CreateNotification = () =>
  import(
    /* webpackChunkName: "messages-notification" */ '@/pages/message/messages/notification/create.vue'
  )
const EditNotification = () =>
  import(
    /* webpackChunkName: "messages-notification" */ '@/pages/message/messages/notification/edit.vue'
  )

export default {
  path: 'notification',
  meta: {
    label: 'notification',
    auth: 'notification'
  },
  component: {
    name: 'Notification',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'MessageMessagesNotification',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Notification
    },
    {
      name: 'MessageCreateMessagesNotification',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateNotification
    },
    {
      name: 'MessageEditMessagesNotification',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditNotification,
      props: true
    }
  ]
}
